<template>
  <div class="wizard-counts">
    <VIcon
      class="mr-1 mr-md-2"
      :color="aiQuestionsLimited ? 'red': 'grey lighten-1'"
    >
      mdi-chat-outline
    </VIcon>
    <span class="mr-1 mr-md-2" :class="aiQuestionsLimited ? 'danger-color': ''">
      <span v-if="!short">{{ $t('selected') }}:</span> {{ questions }} <span v-if="isAiInterviewer">/ 20</span>
    </span>
    <VIcon
      class="mr-1 mr-md-2"
      color="grey lighten-1"
    >
      mdi-clock-outline
    </VIcon>
    <span>
      {{ Number(questionTime * questions).toFixed(0) }} <template v-if="!short">{{ $t('minutes') }}</template>
    </span>
  </div>
</template>

<script>
export default {
  name: 'WizardCounts',
  props: {
    questions: {
      type: Number,
      default: 0,
    },
    short: {
      type: Boolean,
      default: false,
    },
    isAiInterviewer: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      oneQuestionTime: [1.2, 1.3, 1.4, 1.5],
    };
  },
  computed: {
    questionTime() {
      return Number(
        this.oneQuestionTime[Math.floor(Math.random() * this.oneQuestionTime.length)],
      ).toFixed(1);
    },
    aiQuestionsLimited() {
      return this.isAiInterviewer && (this.questions > 20);
    },
  },
};
</script>

<style lang="scss" scoped>
.wizard-counts {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  font-weight: 300;
  font-size: 12px;
  line-height: 25px;
  color: #AAAAAA;

  i {
    font-size: 16px;
  }

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    padding: 0;
    margin-bottom: 10px;
    font-size: 16px;

    i {
      font-size: 20px;
    }
  }
}

.danger-color {
  color: #F44336 !important;
  caret-color: #F44336 !important;
}
</style>

<i18n locale="en" lang="yaml">
  questions: questions | question | questions
  minutes: min
  selected: Selected
</i18n>

<i18n locale="ru" lang="yaml">
  questions: вопросов | вопрос | вопроса | вопросов
  minutes: мин
  selected: Выбрано
</i18n>
